import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/dp-extensions'),
      name: 'dp_extensions',
      component: () =>
        import(
          'dashboard/components-next/dp-extensions/DpExtensions.vue'
        ),
      meta: {
        permissions: [],
      },
    },
  ],
};
